import { DgtPdProductionOrder } from "../models";
import { useEffect, useState, useMemo, useCallback } from 'react'
import { 
  orderByStatusAndDueDate
} from '../graphql/queries'

import { API } from 'aws-amplify'

import { format } from 'date-fns'

import { formatDateObject, getISOStartOfDate } from '../utilities/Format'

import {
  OrderType
} from '../constants/Enum'

import { getOrder } from '../apis'

export default function usePdOrder(
  orderStatus: string,
  orderType: string,
  startDate: Date,
  search: string,
  division: string,
  editSapMasterStatus: string
) : DgtPdProductionOrder[] {
  const [orders, setOrders] = useState<DgtPdProductionOrder[]>([]);

  const fetchSingleOrder = useCallback(async () => {
    const remoteOrder = await getOrder(search)
    const mapDateFormatOrders = [remoteOrder].map(ord => {
      return {
        ...ord,
        dueDate: format(new Date(ord.dueDate), 'dd/MM/yyyy')
      }
    })
    setOrders([...orders, ...mapDateFormatOrders])
  }, [ search, orders ])

  useEffect(() => {
    const fetchRemoteOrders = async (
      status: string,
      ordType: string,
      startD: Date,
      div: string,
      editSapStatus: string
    ) => {
      let fetchedOrders : DgtPdProductionOrder[] = []
      let variables : any = {
        filter: {
          or: [
            { actualDueDate: { ge: formatDateObject(startD) }},
            { updatedAt: { ge: getISOStartOfDate(startD) }}
          ]
        },
        limit: 1000
      }
      if (orderType !== OrderType.ALL) {
        variables.filter = { ...variables.filter, materialType: { eq: ordType }}
      }
      if (editSapStatus !== 'ALL') {
        if (editSapStatus === 'EDIT_WC') {
          variables.filter = { ...variables.filter, countEditWorkCenter: { gt: 0 }}
        }
        else if (editSapStatus === 'EDIT_OPERATION') {
          variables.filter = { ...variables.filter, countEditOperation: { gt: 0 }}
        }
      }
      if (division !== 'ALL') {
        variables.filter = { ...variables.filter, division: { eq: div }}
      }

      variables = { ...variables, statusFromApp: status }
      const queryResult : any = await API.graphql({
        query: orderByStatusAndDueDate,
        variables: variables
      })
      fetchedOrders = queryResult.data?.orderByStatusAndDueDate.items

      if (queryResult.data?.orderByStatusAndDueDate.nextToken) {
        let totalOrders : DgtPdProductionOrder[] = fetchedOrders
        const recursiveGetOrders = async (token: string) => {
          const queryResultAgain : any = await API.graphql({
            query: orderByStatusAndDueDate,
            variables: {
              ...variables,
              nextToken: token
            }
          })
          totalOrders = [...totalOrders, ...queryResultAgain.data?.orderByStatusAndDueDate.items]
          if (queryResultAgain.data?.orderByStatusAndDueDate.nextToken) {
            recursiveGetOrders(queryResultAgain.data?.orderByStatusAndDueDate.nextToken)
          } else {
            const mapDateFormatOrders = totalOrders.map(ord => {
              return {
                ...ord,
                dueDate: format(new Date(ord.dueDate), 'dd/MM/yyyy')
              }
            })
            mapDateFormatOrders.sort((a, b) => a.updatedAt! > b.updatedAt! ? 1 : -1)
            setOrders(mapDateFormatOrders)
          }
        }
        recursiveGetOrders(queryResult.data?.orderByStatusAndDueDate.nextToken)
      }

      const mapDateFormatOrders = fetchedOrders.map(ord => {
				return {
					...ord,
					dueDate: format(new Date(ord.dueDate), 'dd/MM/yyyy')
				}
			})
      mapDateFormatOrders.sort((a, b) => a.updatedAt! > b.updatedAt! ? 1 : -1)
      setOrders(mapDateFormatOrders)
    }
    fetchRemoteOrders(orderStatus, orderType, startDate, division, editSapMasterStatus)
	}, [startDate, orderType, orderStatus, editSapMasterStatus, division])

  const filteredOrders = useMemo(() => orders.filter(ord => ord.id.includes(search)), [ search, orders ])

  if (filteredOrders.length === 0 && search.length === 8) fetchSingleOrder()
  
  return filteredOrders
}